// Harvest Market Immersive Enhancements
// Global scroll progress, section reveals, and atmospheric effects
(function() {
  'use strict';
  
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  
  // === SCROLL PROGRESS BAR ===
  if (!prefersReducedMotion) {
    var progressBar = document.createElement('div');
    progressBar.id = 'hm-scroll-progress';
    progressBar.style.cssText = 'position:fixed;top:0;left:0;height:2px;width:0;background:linear-gradient(90deg,#c9a227,#e8c468);z-index:9999;transition:width 0.1s ease-out;box-shadow:0 0 8px rgba(201,162,39,0.4)';
    document.body.appendChild(progressBar);
    
    function updateProgress() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var percent = (scrolled / total) * 100;
      progressBar.style.width = percent + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }
  
  // === SECTION REVEAL ANIMATIONS ===
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hm-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    
    // Observe all immersive section headers and content blocks
    var selectors = [
      '.cj-section-header',
      '.fcr-header',
      '.ebp-header',
      '.om-header',
      '.eoc-header',
      '.sf-fn-header',
      '.byb-header',
      '.ps-header',
      '.fcr-card',
      '.ebp-card',
      '.eoc-card',
      '.sf-fn-card',
      '.byb-stat',
      '.byb-feature',
      '.ps-milestone',
      '.ps-cta',
      '.om-wrap',
      '.brand-cards-section'
    ];
    
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.classList.add('hm-reveal');
        revealObserver.observe(el);
      });
    });
  }
  
  // === ACTIVE SECTION HIGHLIGHT IN JOURNEY STRIP ===
  var journeyStrip = document.querySelector('.ih-journey-strip');
  if (journeyStrip && !prefersReducedMotion && !isMobile) {
    var journeyItems = journeyStrip.querySelectorAll('.ih-journey-item');
    var journeySection = document.querySelector('.coffee-journey');
    
    if (journeySection && journeyItems.length > 0) {
      var stages = journeySection.querySelectorAll('.cj-stage');
      
      stages.forEach(function(stage, index) {
        if (index < journeyItems.length) {
          var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                journeyItems.forEach(function(item) { item.classList.remove('active'); });
                journeyItems[index].classList.add('active');
              }
            });
          }, { threshold: 0.3 });
          observer.observe(stage);
        }
      });
    }
  }
  
  // === SMOOTH SCROLL FOR ANCHOR LINKS ===
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });
})();